import HomeCta from "@/components/sections/home/cta";
import SectionNav from "@/components/sections/shared/section-nav";
import BuyerChecklist from "./buyer-checklist";
import CategoryArchive from "./category-archive";
import ConfigExample from "./config-example";
import DynamicCards from "./dynamic-cards";
import ProxyServerFaq from "./faq";
import { getProxyArticleCards } from "./fetch";
import ProxyServerHero from "./hero";
import HowItWorks from "./how-it-works";
import ProductOptions from "./product-options";
import ProsCons from "./pros-cons";
import ProxyDoesAndDoesnt from "./proxy-does-and-doesnt";
import ProxySelector from "./proxy-selector";
import QuickAnswer from "./quick-answer";
import VpnComparison from "./vpn-comparison";

const SECTIONS = [
  { id: "quick-answer-heading", label: "Quick Answer" },
  { id: "proxy-selector-heading", label: "Which Type?" },
  { id: "how-it-works-heading", label: "How It Works" },
  { id: "proxy-does-and-doesnt-heading", label: "Does & Doesn't" },
  { id: "proxy-categories-heading", label: "Proxy Types" },
  { id: "buyer-checklist-heading", label: "How to Choose" },
  { id: "pros-cons-heading", label: "Pros & Cons" },
  { id: "proxy-vs-vpn-heading", label: "vs. VPN" },
  { id: "config-example-heading", label: "Config Example" },
  { id: "product-options-heading", label: "Products" },
  { id: "proxy-server-faq-heading", label: "FAQ" },
];

export default async function ProxyServerPostSection() {
  const cards = await getProxyArticleCards();

  return (
    <main id="main-content" tabIndex={-1}>
      <ProxyServerHero />
      <SectionNav sections={SECTIONS} />
      <QuickAnswer />
      <ProxySelector />
      <HowItWorks />
      <ProxyDoesAndDoesnt />
      <CategoryArchive />
      <DynamicCards cards={cards} />
      <BuyerChecklist />
      <ProsCons />
      <VpnComparison />
      <ConfigExample />
      <ProductOptions />
      <ProxyServerFaq />
      <HomeCta />
    </main>
  );
}
